import { memo } from "react";

import { BlueprintDeploymentStack } from "types/generated";
import TableSimple from "ds/components/TableSimple";

import useTemplateDeploymentStacksTableStore from "./useTemplateDeploymentStacksTableStore";
import { TEMPLATE_DEPLOYMENT_STACKS_TABLE_CELLS } from "./Cells";

type TemplateDeploymentStacksTableProps = {
  stacks: BlueprintDeploymentStack[];
};

const TemplateDeploymentStacksTable = ({ stacks }: TemplateDeploymentStacksTableProps) => {
  return (
    <TableSimple
      data={stacks}
      store={useTemplateDeploymentStacksTableStore}
      ariaLabel="Deployment stacks table"
      cellPerColumn={TEMPLATE_DEPLOYMENT_STACKS_TABLE_CELLS}
      hasPagination={false}
    />
  );
};

export default memo(TemplateDeploymentStacksTable);
